module.exports = __webpack_public_path__ + "static/HR Smartphone App AbaClik Meine Daten Personalien 2-8214f44acae51fe8b3f911e75e3704b4.png";